import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'
import { formatContent, MessageData } from '@/services/message.service'

export interface MessageListReq {
  /** 每页条数 */
  limit?: number
  /** 页码 */
  page?: number
}

export interface MessageListRes {
  data?: MessageData[]
  total?: number
}

@Injectable()
export class MessageDetailsService {
  constructor (private http: Http) {}


  @ParamsClean()
  getMessageList (data: MessageListReq) {
    return this.http.post<MessageListRes>('/message/list', data).then(res => {
      res.data.forEach(v => v.content = formatContent(v.content))


      return res
    })
  }
}

